import { render, staticRenderFns } from "./BaseUserProfile.vue?vue&type=template&id=d721f91c&scoped=true&"
import script from "./BaseUserProfile.vue?vue&type=script&lang=js&"
export * from "./BaseUserProfile.vue?vue&type=script&lang=js&"
import style0 from "./BaseUserProfile.vue?vue&type=style&index=0&id=d721f91c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d721f91c",
  null
  
)

export default component.exports